import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Tags from '../components/tags';
import Social from '../components/social';
import "./about.css";
import aboutImage from '../images/about_image.jpg'


const AboutPage = () => (
  <>
      <br/>
    <h4
    className="title"
    >ABOUT</h4>
    <div>
      <div className="aboutTitle">
      <h2>CreareMondi.it</h2>
      </div>
      <div className="aboutQuote">
      <p>Le Porte di Durin, Signore di Moria. Dite ‘amici’ ed entrate. Io, Narvi, le feci, Celebrimbor dell’Agrifogliere tracciò questi segni.</p>
<p>- La Compagnia dell’Anello, J. R. R. Tolkien, traduzione dal Sindarin</p>
      </div>
      <div className="aboutHeader">
        <img alt="author" style={{
          width: 200, height: 200, minWidth: 200}
          } src={aboutImage}>
        </img>
        <div class="aboutHeaderText">
        <p>Mi chiamo Simone Schiaffella, sono nato nel 1992 e sono, come tutti gli
appassionati dell’universo fantasy e delle storie, un viaggiatore di mondi.
Nel 2017 ero a CaLibro, Festival della lettura che si svolge ogni anno a Città di Castello, in provincia di Perugia. In una bella giornata di sole, tra una lettura all’aperto e una presentazione, la mia attenzione fu catturata da due libri che, in particolare, fanno parte della storia di questo blog.
</p></div>
      </div>
      <div className="aboutBody">
      <p>Il primo è <i>La stanza profonda</i>, di Vanni Santoni, un romanzo sul medium del gioco di ruolo che è stato tra la rosa dei finalisti al premio Strega del 2017; il secondo è <i>Di tutti i mondi possibili</i>, una raccolta di 9 saggi sui topoi del fantasy a cura di Silvia Costantino, con prefazione di Licia Troisi.</p>
<p>Quest’ultimo è un libro nero, dalla forma particolare - quasi quadrata - con un editing grafico di pregio. Sulla copertina c’è la raffigurazione dell’uroboro, il serpente che si morde la coda e che chiude un cerchio senza inizio né fine simboleggiando l’eterno ritorno.</p>
<p>Col senno di poi, mi domando che cosa mi abbia spinto verso questo volumetto con tale magnetismo.
È stata forse la promessa di ritrovarvi all’interno delle riflessioni che richiamassero quelle che avevo affrontato all’Università nei corsi sul fandom, sull’immaginario e sugli archetipi narrativi?</p>
<p>È stato il nome di Licia Troisi che, con il suo <i>Cronache del Mondo Emerso</i>, fu tra le prime scrittrici che mi accompagnarono – tredicenne – in un mondo fantastico?</p>
<p>O era stato il marchio dell’uroboro a suscitare in me quell’attrazione? Del resto, anche Bastiano aveva rubato il libro di storie fantastiche de <i>La storia infinita</i> senza porsi troppe domande. Sulla copertina non c’era forse un simbolo simile a quello, con due serpenti annodati a mordersi le reciproche code?</p>
<p>Qualunque sia il motivo, è anche grazie a quella raccolta di saggi - quella raccolta di voci - che oggi ho deciso di aggiungere la mia, di voce, alla discussione sul fantasy e sull’immaginario.

Come ogni viandante, non sono ben sicuro di dove il mio viaggio mi porterà. Sono sicuro, però, che ne sarò tanto più arricchito quanto più deciderò di mettere in gioco me stesso e le mie convinzioni.</p>
<p>Il primo ringraziamento va a Voi: questo blog, come ogni storia, non esisterebbe senza i suoi lettori. Nessun mondo esiste senza le persone che lo abitano, e spero che <i>CreareMondi.it</i> entri a far parte della comunità di appassionati che, in Italia, esiste, sogna, crea, ed è viva e pulsante.</p>
<p>Se avete deciso di accompagnarmi in questo viaggio, per un tratto breve oppure lungo, allora non vi resta che fare una cosa:</p></div>
<div className="aboutFooter">
Dite ‘amici’ ed entrate.
</div>
    
 
<p className="aboutDate">3 aprile 2019</p>



    </div>
    </>
)

export default AboutPage
